<div
  class="d-flex align-items-center justify-content-center h-100 py-3 flex-column"
>
  <!-- KILOMETRAJE -->
  <div
    *appHasPermission="'dashboard_descriptiveGraphic_trapDistance'"
    class="w-100 px-5"
  >
    <div
      class="d-flex flex-row justify-content-start align-self-start gap-3 mb-3 px-3"
    >
      <button
        pButton
        pRipple
        type="button"
        (click)="toggleShowMileageGraphs()"
        [icon]="showMileageGraphs ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        class="p-button-sm p-button-rounded p-button-text"
        style="color: #6c757d"
      ></button>
      <div class="text-uppercase fw-light" style="font-size: 1.2rem">
        Históricos de kilometraje
      </div>
      <div class="align-content-center position-relative"></div>
    </div>
    <div
      *ngIf="allDataLoadedOfMileage && showMileageGraphs"
      class="w-100 sortable-list d-flex flex-wrap gap-4 justify-content-center pb-3"
    >
      <ng-container>
        <div
          class="item px-4 py-1"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              Resumen del kilometraje
            </div>
            <div class="d-flex flex-row align-items-center gap-2">
              <button
                pButton
                pRipple
                type="button"
                (click)="toggleShowMoreMileageGraphs()"
                [icon]="showMoreMileageGraphs ? 'pi pi-minus' : 'pi pi-plus'"
                class="p-button-sm p-button-rounded p-button-text"
                style="color: #6c757d"
              ></button>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <!-- <app-chart
            class="w-100 ratio ratio-16x9"
            [data]="data"
            [type]="data.datasets[0].type"
            [options]="chartsConfig[data.id]"
          ></app-chart> -->

            <!-- table -->
            <!-- <div class=" w-100 ratio ratio-16x9">
            <p-table
              [value]="products"
              styleClass="p-datatable-sm border-none"
              [scrollable]="true"
              scrollHeight="flex"
              selectionMode="single"
              dataKey="code"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Quantity</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.code }}</td>
                  <td>{{ product.name }}</td>
                  <td>{{ product.category }}</td>
                  <td>{{ product.quantity }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div> -->
            <!-- resumen -->
            <div class="w-100 ratio ratio-16x9">
              <div class="d-flex flex-column justify-content-around w-100">
                <div class="d-flex flex-row justify-content-center">
                  <div class="d-flex flex-column gap-2">
                    <div
                      class="fw-light text-nowrap overflow-hidden text-truncate"
                      style="font-size: 1.1rem"
                    >
                      Distancia conducida en este periodo
                    </div>
                    <div class="d-flex flex-row">
                      <div class="fw-light" style="font-size: 4rem">
                        {{ currentTotalMileage | number : "1.2-2" }}
                      </div>
                      <div
                        class="p-2 d-flex flex-column justify-content-center gap-1"
                      >
                        <div class="fw-bold" *ngIf="false">
                          {{ mileageVariation }}%
                          <i
                            [ngClass]="
                              mileageVariation < 0
                                ? 'pi pi-arrow-down'
                                : 'pi pi-arrow-up'
                            "
                          ></i>
                        </div>
                        <div class="fw-light" style="font-size: 2rem">km</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-column flex-fill align-items-center justify-content-center"
                    *ngIf="false"
                  >
                    <div class="fw-light text-center" style="font-size: 0.9rem">
                      Periodo anterior
                    </div>
                    <div class="fw-light" style="font-size: 0.9rem">
                      {{ totalMileageBefore }} km
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-row gap-1 justify-content-center">
                  <div
                    class="fw-light d-flex align-items-center justify-content-center"
                    style="
                      font-size: 0.9rem;
                      width: clamp(30%, calc(50% - 1rem), 50%);
                    "
                  >
                    <div>Total de Unidades: {{ unitsMileageTotal }}</div>
                  </div>
                  <div
                    class="d-flex flex-column"
                    style="width: clamp(30%, calc(50% - 1rem), 50%)"
                  >
                    <div
                      class="fw-light d-flex flex-row gap-1 align-items-center"
                    >
                      <div>Unidades con</div>
                      <div pTooltip="GPS" tooltipPosition="top">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0m-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
                          />
                        </svg>
                      </div>
                      <div>:{{ gpsMileageUnits }}</div>
                    </div>
                    <div
                      class="fw-light d-flex flex-row gap-1 align-items-center"
                    >
                      <div>Unidades con</div>

                      <div pTooltip="CIPIA" tooltipPosition="top">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                          />
                          <path
                            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                          />
                        </svg>
                      </div>
                      <div>:{{ cipiaMileageUnits }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!showMoreMileageGraphs">
        <div
          style="
            background-color: rgb(255, 255, 255);
            width: clamp(350px, calc(30% - 3rem), 30%);
          "
        ></div>
        <div
          style="
            background-color: rgb(255, 255, 255);
            width: clamp(350px, calc(30% - 3rem), 30%);
          "
        ></div>
      </ng-container>
      <ng-container *ngIf="showMoreMileageGraphs">
        <div
          class="item px-4 py-1"
          *ngFor="let mileageChartData of mileageChartsData; let i = index"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              {{ mileageChartsTitles[i] }}
            </div>
            <div
              class="d-flex flex-row align-items-center gap-2"
              style="min-width: fit-content"
            >
              <p-button
                label="Ver más"
                (click)="
                  showChartInDialog(
                    mileageChartsFull[i],
                    mileageChartsConfig[i],
                    mileageChartsTitles[i],
                    mileageChartsTotals[i]?.all
                  )
                "
                styleClass="p-button-link w-100"
              ></p-button>

              <button
                *appHasPermission="'reports_module'"
                type="button"
                pButton
                pRipple
                icon="pi pi-ellipsis-v"
                class="p-button-rounded p-button-text"
                (click)="menu.toggle($event)"
              ></button>
              <p-menu #menu [popup]="true" [model]="items"></p-menu>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <app-chart
              class="w-100 ratio ratio-16x9"
              [data]="mileageChartData"
              [type]="mileageChartData.datasets[0].type"
              [options]="mileageChartsConfig[i]"
              [isEmpty]="mileageChartData.datasets[0].data.length == 0"
            ></app-chart>

            <!-- table -->
            <!-- <div class="w-100 ratio ratio-16x9">
              <p-table
                [value]="products"
                styleClass="p-datatable-sm border-none"
                [scrollable]="true"
                scrollHeight="flex"
                selectionMode="single"
                dataKey="code"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Quantity</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                  <tr>
                    <td>{{ product.code }}</td>
                    <td>{{ product.name }}</td>
                    <td>{{ product.category }}</td>
                    <td>{{ product.quantity }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div> -->

            <!-- resumen -->
            <!-- <div class="w-100 ratio ratio-16x9">
              <div class="d-flex flex-column justify-content-around">
                <div class="d-flex flex-row">
                  <div class="d-flex flex-column gap-2">
                    <div class="fw-light" style="font-size: 1.1rem">
                      Distancia conducida en este periodo
                    </div>
                    <div class="d-flex flex-row">
                      <div class="fw-light" style="font-size: 5rem">
                        {{ "86387.3" }}
                      </div>
                      <div
                        class="p-2 d-flex flex-column justify-content-center gap-1"
                      >
                        <div class="fw-bold">
                          {{ "-35" }}%
                          <i
                            [ngClass]="
                              false ? 'pi pi-arrow-down' : 'pi pi-arrow-up'
                            "
                          ></i>
                        </div>
                        <div class="fw-light" style="font-size: 2rem">km</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-column flex-fill align-items-center justify-content-center"
                  >
                    <div class="fw-light" style="font-size: 0.9rem">
                      Periodo anterior
                    </div>
                    <div class="fw-light" style="font-size: 0.9rem">
                      {{ "133864.7" }} km
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-row gap-1 justify-content-center">
                  <div
                    class="fw-light d-flex align-items-center justify-content-center"
                    style="font-size: 0.9rem; width: clamp(30%, 40%, 50%)"
                  >
                    <div>Total de Unidades: {{ "687" }}</div>
                  </div>
                  <div
                    class="d-flex flex-column"
                    style="width: clamp(30%, 40%, 50%)"
                  >
                    <div
                      class="fw-light d-flex flex-row gap-1 align-items-center"
                    >
                      <div>Unidades con</div>
                      <div pTooltip="GPS" tooltipPosition="top">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0m-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
                          />
                        </svg>
                      </div>
                      <div>:{{ "387" }}</div>
                    </div>
                    <div
                      class="fw-light d-flex flex-row gap-1 align-items-center"
                    >
                      <div>Unidades con</div>

                      <div pTooltip="CIPIA" tooltipPosition="top">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                          />
                          <path
                            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                          />
                        </svg>
                      </div>
                      <div>:{{ "387" }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="!allDataLoadedOfMileage && showMileageGraphs"
      class="w-100 justify-content-center d-flex flex-row"
    >
      <div
        class="ratio ratio-1x1 d-flex flex-column align-content-center justify-content-center"
        style="width: 350px"
      >
        <div
          class="d-flex flex-column justify-content-center align-content-center align-items-center"
        >
          <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
          <div class="d-flex flex-row gap-2">
            <div>Cargando</div>
            <div>datos</div>
            <div>...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- COMBUSTIBLE -->
  <div
    *appHasPermission="'dashboard_descriptiveGraphic_trapDistance'"
    class="w-100 px-5"
  >
    <div
      class="d-flex flex-row justify-content-start align-self-start gap-3 mb-3 px-3"
    >
      <button
        pButton
        pRipple
        type="button"
        (click)="toggleShowFuelGraphs()"
        [icon]="showMileageGraphs ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
        class="p-button-sm p-button-rounded p-button-text"
        style="color: #6c757d"
      ></button>
      <div class="text-uppercase fw-light" style="font-size: 1.2rem">
        Históricos de Combustible
      </div>
      <div class="align-content-center position-relative"></div>
    </div>
    <div
      *ngIf="allDataLoadedOfFuel && showFuelGraphs"
      class="w-100 sortable-list d-flex flex-wrap gap-4 justify-content-center pb-3"
    >
      <ng-container>
        <div
          class="item px-4 py-1"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              Resumen del Combustible
            </div>
            <div class="d-flex flex-row align-items-center gap-2">
              <button
                pButton
                pRipple
                type="button"
                (click)="toggleShowMoreFuelGraphs()"
                [icon]="showMoreFuelGraphs ? 'pi pi-minus' : 'pi pi-plus'"
                class="p-button-sm p-button-rounded p-button-text"
                style="color: #6c757d"
              ></button>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <!-- <app-chart
            class="w-100 ratio ratio-16x9"
            [data]="data"
            [type]="data.datasets[0].type"
            [options]="chartsConfig[data.id]"
          ></app-chart> -->

            <!-- table -->
            <!-- <div class=" w-100 ratio ratio-16x9">
            <p-table
              [value]="products"
              styleClass="p-datatable-sm border-none"
              [scrollable]="true"
              scrollHeight="flex"
              selectionMode="single"
              dataKey="code"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Quantity</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.code }}</td>
                  <td>{{ product.name }}</td>
                  <td>{{ product.category }}</td>
                  <td>{{ product.quantity }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div> -->
            <!-- resumen -->
            <div class="w-100 ratio ratio-16x9">
              <div class="d-flex flex-column justify-content-around w-100">
                <div class="d-flex flex-row justify-content-center">
                  <div class="d-flex flex-column gap-2">
                    <div
                      class="fw-light text-nowrap overflow-hidden text-truncate"
                      style="font-size: 1.1rem"
                    >
                      Combustible consumido en este periodo
                    </div>
                    <div class="d-flex flex-row">
                      <div class="fw-light" style="font-size: 4rem">
                        {{ currentTotalFuel | number : "1.2-2" }}
                      </div>
                      <div
                        class="p-2 d-flex flex-column justify-content-center gap-1"
                      >
                        <div class="fw-bold" *ngIf="false">
                          {{ fuelVariation }}%
                          <i
                            [ngClass]="
                              fuelVariation < 0
                                ? 'pi pi-arrow-down'
                                : 'pi pi-arrow-up'
                            "
                          ></i>
                        </div>
                        <div
                          class="fw-light"
                          style="font-size: 2rem; cursor: pointer"
                          (click)="changeAverageUnit()"
                        >
                          {{ averageUnit }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-column flex-fill align-items-center justify-content-center"
                    *ngIf="false"
                  >
                    <div class="fw-light text-center" style="font-size: 0.9rem">
                      Periodo anterior
                    </div>
                    <div class="fw-light" style="font-size: 0.9rem">
                      {{ totalFuelBefore }} Lts
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-row gap-1 justify-content-center">
                  <div
                    class="fw-light d-flex align-items-center justify-content-center"
                    style="
                      font-size: 0.9rem;
                      width: clamp(30%, calc(50% - 1rem), 50%);
                    "
                  >
                    <div>Total de Unidades: {{ unitsFuelTotal }}</div>
                  </div>
                  <div
                    class="d-flex flex-column"
                    style="width: clamp(30%, calc(50% - 1rem), 50%)"
                  >
                    <div
                      class="fw-light d-flex flex-row gap-1 align-items-center"
                    >
                      <div>Unidades con</div>
                      <div pTooltip="GPS" tooltipPosition="top">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0m-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
                          />
                        </svg>
                      </div>
                      <div>:{{ gpsFuelUnits }}</div>
                    </div>
                    <div
                      class="fw-light d-flex flex-row gap-1 align-items-center"
                    >
                      <div>Unidades con</div>

                      <div pTooltip="CIPIA" tooltipPosition="top">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                          />
                          <path
                            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                          />
                        </svg>
                      </div>
                      <div>:{{ cipiaFuelUnits }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!showMoreFuelGraphs">
        <div
          style="
            background-color: rgb(255, 255, 255);
            width: clamp(350px, calc(30% - 3rem), 30%);
          "
        ></div>
        <div
          style="
            background-color: rgb(255, 255, 255);
            width: clamp(350px, calc(30% - 3rem), 30%);
          "
        ></div>
      </ng-container>
      <ng-container *ngIf="showMoreFuelGraphs">
        <div
          class="item px-4 py-1"
          *ngFor="let fuelChartData of fuelChartsData; let i = index"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              {{ fuelChartsTitles[i] }}
            </div>
            <div
              class="d-flex flex-row align-items-center gap-2"
              style="min-width: fit-content"
            >
              <p-button
                label="Ver más"
                (click)="
                  showChartInDialog(
                    fuelChartsFull[i],
                    fuelChartsConfig[i],
                    fuelChartsTitles[i],
                    fuelChartsTotals[i]?.all
                  )
                "
                styleClass="p-button-link w-100"
              ></p-button>

              <button
                *appHasPermission="'reports_module'"
                type="button"
                pButton
                pRipple
                icon="pi pi-ellipsis-v"
                class="p-button-rounded p-button-text"
                (click)="menu.toggle($event)"
              ></button>
              <p-menu #menu [popup]="true" [model]="items"></p-menu>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <app-chart
              class="w-100 ratio ratio-16x9"
              [data]="fuelChartData"
              [type]="fuelChartData.datasets[0].type"
              [options]="fuelChartsConfig[i]"
              [isEmpty]="fuelChartData.datasets[0].data.length == 0"
            ></app-chart>

            <!-- table -->
            <!-- <div class="w-100 ratio ratio-16x9">
              <p-table
                [value]="products"
                styleClass="p-datatable-sm border-none"
                [scrollable]="true"
                scrollHeight="flex"
                selectionMode="single"
                dataKey="code"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Quantity</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                  <tr>
                    <td>{{ product.code }}</td>
                    <td>{{ product.name }}</td>
                    <td>{{ product.category }}</td>
                    <td>{{ product.quantity }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div> -->

            <!-- resumen -->
            <!-- <div class="w-100 ratio ratio-16x9">
              <div class="d-flex flex-column justify-content-around">
                <div class="d-flex flex-row">
                  <div class="d-flex flex-column gap-2">
                    <div class="fw-light" style="font-size: 1.1rem">
                      Distancia conducida en este periodo
                    </div>
                    <div class="d-flex flex-row">
                      <div class="fw-light" style="font-size: 5rem">
                        {{ "86387.3" }}
                      </div>
                      <div
                        class="p-2 d-flex flex-column justify-content-center gap-1"
                      >
                        <div class="fw-bold">
                          {{ "-35" }}%
                          <i
                            [ngClass]="
                              false ? 'pi pi-arrow-down' : 'pi pi-arrow-up'
                            "
                          ></i>
                        </div>
                        <div class="fw-light" style="font-size: 2rem">km</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-column flex-fill align-items-center justify-content-center"
                  >
                    <div class="fw-light" style="font-size: 0.9rem">
                      Periodo anterior
                    </div>
                    <div class="fw-light" style="font-size: 0.9rem">
                      {{ "133864.7" }} km
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-row gap-1 justify-content-center">
                  <div
                    class="fw-light d-flex align-items-center justify-content-center"
                    style="font-size: 0.9rem; width: clamp(30%, 40%, 50%)"
                  >
                    <div>Total de Unidades: {{ "687" }}</div>
                  </div>
                  <div
                    class="d-flex flex-column"
                    style="width: clamp(30%, 40%, 50%)"
                  >
                    <div
                      class="fw-light d-flex flex-row gap-1 align-items-center"
                    >
                      <div>Unidades con</div>
                      <div pTooltip="GPS" tooltipPosition="top">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0m-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
                          />
                        </svg>
                      </div>
                      <div>:{{ "387" }}</div>
                    </div>
                    <div
                      class="fw-light d-flex flex-row gap-1 align-items-center"
                    >
                      <div>Unidades con</div>

                      <div pTooltip="CIPIA" tooltipPosition="top">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                          />
                          <path
                            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                          />
                        </svg>
                      </div>
                      <div>:{{ "387" }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="!allDataLoadedOfFuel && showFuelGraphs"
      class="w-100 justify-content-center d-flex flex-row"
    >
      <div
        class="ratio ratio-1x1 d-flex flex-column align-content-center justify-content-center"
        style="width: 350px"
      >
        <div
          class="d-flex flex-column justify-content-center align-content-center align-items-center"
        >
          <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
          <div class="d-flex flex-row gap-2">
            <div>Cargando</div>
            <div>datos</div>
            <div>...</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- RANKING DE EVENTOS POR CONDUCTOR -->
  <div
    *appHasPermission="'dashboard_descriptiveGraphic_eventsDrivers'"
    class="w-100 px-5"
  >
    <div
      class="d-flex flex-row justify-content-start align-self-start gap-3 mb-3 px-3"
    >
      <button
        pButton
        pRipple
        type="button"
        (click)="toggleShowEventsByDriverGraphs()"
        [icon]="
          showEventsByDriverGraphs ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
        "
        class="p-button-sm p-button-rounded p-button-text"
        style="color: #6c757d"
      ></button>
      <div class="text-uppercase fw-light" style="font-size: 1.2rem">
        RANKING DE EVENTOS POR CONDUCTOR
      </div>
      <div class="align-content-center position-relative"></div>
    </div>
    <div
      *ngIf="allDataLoadedOfEventsByDriver && showEventsByDriverGraphs"
      class="w-100 sortable-list d-flex flex-wrap justify-content-center pb-3 gap-4"
    >
      <ng-container>
        <div
          class="item px-4 py-1"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
            height: fit-content;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              Eventos por conductor
            </div>
            <div class="d-flex flex-row align-items-center gap-2">
              <button
                pButton
                pRipple
                type="button"
                (click)="toggleShowMoreEventsByDriverGraphs()"
                [icon]="
                  showMoreEventsByDriverGraphs ? 'pi pi-minus' : 'pi pi-plus'
                "
                class="p-button-sm p-button-rounded p-button-text"
                style="color: #6c757d"
              ></button>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <!-- table -->
            <div class="w-100 ratio ratio-1x1">
              <p-table
                *ngIf="showTableOfEventsByDriver && eventsByDriver.length > 0"
                [value]="driverEvents"
                styleClass="p-datatable-sm border-none"
                [scrollable]="true"
                scrollHeight="flex"
                selectionMode="single"
                dataKey="id"
                (onRowSelect)="onRowSelectInTableEventsByDriver($event)"
                [style]="{ 'font-size': '0.8rem' }"
              >
                <ng-template pTemplate="colgroup" let-columns>
                  <colgroup>
                    <col style="width: 40%" />
                    <col style="width: 40%" />
                    <col style="width: 20%" />
                  </colgroup>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="driver">Conductor</th>
                    <th pSortableColumn="unit.operation">Operación</th>
                    <th pSortableColumn="events">Nro. de eventos</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-eventsByDriver>
                  <tr [pSelectableRow]="eventsByDriver">
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ eventsByDriver?.driver }}
                    </td>
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ eventsByDriver?.operation }}
                    </td>
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ eventsByDriver?.events }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <div
                *ngIf="eventsByDriver.length == 0"
                class="d-flex flex-column flex-fill justify-content-evenly gap-2"
              >
                <div style="color: gray" class="d-flex justify-content-center">
                  <svg fill="currentColor" viewBox="0 0 16 16" width="30%">
                    <path
                      d="M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465m-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1"
                    />
                    <path
                      d="M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7m6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.55 4.55 0 0 1 .23-2.002m-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-1.3-1.905"
                    />
                  </svg>
                </div>
                <div class="h3 text-center fw-semibold" style="color: gray">
                  No hay datos disponibles!
                </div>
                <div class="h5 text-center fw-light" style="color: gray">
                  No hay datos para mostrarte en este periodo
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div style="width: clamp(350px, calc(60% - 4.5rem), 60%)">
        <div class="sortable-list d-flex flex-wrap gap-4 justify-content-start">
          <ng-container *ngIf="!showMoreEventsByDriverGraphs">
            <div
              style="
                background-color: rgb(255, 255, 255);
                width: clamp(350px, calc(30% - 3rem), 30%);
              "
            ></div>
            <div
              style="
                background-color: rgb(255, 255, 255);
                width: clamp(350px, calc(30% - 3rem), 30%);
              "
            ></div>
          </ng-container>
          <ng-container
            *ngIf="showMoreEventsByDriverGraphs && selectEventByDriver"
          >
            <div
              class="item px-4 py-1"
              *ngFor="let eventsByDriverChartData of eventsByDriverChartsData"
              style="
                background-color: rgb(255, 255, 255);
                border-radius: 6px;
                border: 1px solid rgb(180, 180, 180);
                width: clamp(350px, calc(50% - 0.75rem), 50%);
              "
            >
              <div
                class="d-flex flex-row justify-content-between align-self-center py-1"
              >
                <div
                  class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
                >
                  {{ eventsByDriverChartsTitles[eventsByDriverChartData.id] }}
                </div>
                <div
                  class="d-flex flex-row align-items-center gap-2"
                  style="min-width: fit-content"
                >
                  <p-button
                    label="Ver más"
                    (click)="
                      showChartInDialog(
                        eventsByDriverChartsFull[eventsByDriverChartData.id],
                        eventsByDriverChartsConfig[eventsByDriverChartData.id],
                        eventsByDriverChartsTitles[eventsByDriverChartData.id],
                        eventsByDriverChartsTotals[eventsByDriverChartData.id]
                          ?.all
                      )
                    "
                    styleClass="p-button-link w-100"
                  ></p-button>

                  <button
                    *appHasPermission="'reports_module'"
                    type="button"
                    pButton
                    pRipple
                    icon="pi pi-ellipsis-v"
                    class="p-button-rounded p-button-text"
                    (click)="menu.toggle($event)"
                  ></button>
                  <p-menu #menu [popup]="true" [model]="items"></p-menu>
                </div>
              </div>
              <div class="d-flex flex-row justify-content-between">
                <app-chart
                  class="w-100 ratio ratio-16x9"
                  [data]="eventsByDriverChartData"
                  [type]="eventsByDriverChartData.datasets[0].type"
                  [options]="
                    eventsByDriverChartsConfig[eventsByDriverChartData.id]
                  "
                  [isEmpty]="
                    eventsByDriverChartData.datasets[0].data.length == 0
                  "
                ></app-chart>

                <!-- table -->
                <!-- <div class="w-100 ratio ratio-16x9">
            <p-table
              [value]="products"
              styleClass="p-datatable-sm border-none"
              [scrollable]="true"
              scrollHeight="flex"
              selectionMode="single"
              dataKey="code"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Quantity</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.code }}</td>
                  <td>{{ product.name }}</td>
                  <td>{{ product.category }}</td>
                  <td>{{ product.quantity }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div> -->

                <!-- resumen -->
                <!-- <div class="w-100 ratio ratio-16x9">
            <div class="d-flex flex-column justify-content-around">
              <div class="d-flex flex-row">
                <div class="d-flex flex-column gap-2">
                  <div class="fw-light" style="font-size: 1.1rem">
                    Distancia conducida en este periodo
                  </div>
                  <div class="d-flex flex-row">
                    <div class="fw-light" style="font-size: 5rem">
                      {{ "86387.3" }}
                    </div>
                    <div
                      class="p-2 d-flex flex-column justify-content-center gap-1"
                    >
                      <div class="fw-bold">
                        {{ "-35" }}%
                        <i
                          [ngClass]="
                            false ? 'pi pi-arrow-down' : 'pi pi-arrow-up'
                          "
                        ></i>
                      </div>
                      <div class="fw-light" style="font-size: 2rem">km</div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-fill align-items-center justify-content-center"
                >
                  <div class="fw-light" style="font-size: 0.9rem">
                    Periodo anterior
                  </div>
                  <div class="fw-light" style="font-size: 0.9rem">
                    {{ "133864.7" }} km
                  </div>
                </div>
              </div>

              <div class="d-flex flex-row gap-1 justify-content-center">
                <div
                  class="fw-light d-flex align-items-center justify-content-center"
                  style="font-size: 0.9rem; width: clamp(30%, 40%, 50%)"
                >
                  <div>Total de Unidades: {{ "687" }}</div>
                </div>
                <div
                  class="d-flex flex-column"
                  style="width: clamp(30%, 40%, 50%)"
                >
                  <div
                    class="fw-light d-flex flex-row gap-1 align-items-center"
                  >
                    <div>Unidades con</div>
                    <div pTooltip="GPS" tooltipPosition="top">
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0m-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
                        />
                      </svg>
                    </div>
                    <div>:{{ "387" }}</div>
                  </div>
                  <div
                    class="fw-light d-flex flex-row gap-1 align-items-center"
                  >
                    <div>Unidades con</div>

                    <div pTooltip="CIPIA" tooltipPosition="top">
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                        />
                        <path
                          d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                        />
                      </svg>
                    </div>
                    <div>:{{ "387" }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
              </div>
            </div>
            <div
              *ngIf="false"
              class="item px-4 py-1"
              style="
                background-color: rgb(255, 255, 255);
                border-radius: 6px;
                border: 1px solid rgb(180, 180, 180);
                width: clamp(350px, calc(100%), 100%);
              "
            >
              <div
                class="d-flex flex-row justify-content-between align-self-center py-1"
              >
                <div
                  class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
                >
                  Mapa de calor de eventos por unidades del conductor
                </div>
                <div
                  class="d-flex flex-row align-items-center gap-2"
                  style="min-width: fit-content"
                >
                  <p-button
                    label="mostrar grafico"
                    (click)="showOfHeatMapEventsByDrivers()"
                    styleClass="p-button-link w-100"
                  ></p-button>
                  <button
                    *appHasPermission="'reports_module'"
                    type="button"
                    pButton
                    pRipple
                    icon="pi pi-ellipsis-v"
                    class="p-button-rounded p-button-text"
                    (click)="menu.toggle($event)"
                  ></button>
                  <p-menu #menu [popup]="true" [model]="items"></p-menu>
                </div>
              </div>
              <div class="d-flex flex-row justify-content-between">
                <app-chart
                  *ngIf="showHeatMapEventsByDrivers"
                  class="w-100 ratio ratio-16x9"
                  [data]="generalEventsNgxChartsData"
                  [type]="eventsByDriverChartsMoreOptions[0].type"
                  [options]="{}"
                  [isEmpty]="generalEventsNgxChartsData.length == 0"
                  [library]="eventsByDriverChartsMoreOptions[0].library"
                  [colors]="eventsByDriverChartsMoreOptions[0].colors"
                ></app-chart>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      *ngIf="!allDataLoadedOfEventsByDriver && showEventsByDriverGraphs"
      class="w-100 justify-content-center d-flex flex-row"
    >
      <div
        class="ratio ratio-1x1 d-flex flex-column align-content-center justify-content-center"
        style="width: 350px"
      >
        <div
          class="d-flex flex-column justify-content-center align-content-center align-items-center"
        >
          <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
          <div class="d-flex flex-row gap-2">
            <div>Cargando</div>
            <div>datos</div>
            <div>...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- RANKING DE EVENTOS CONFIRMADOS POR CONDUCTOR -->
  <!-- <div class="w-100 px-5">
    <div
      class="d-flex flex-row justify-content-start align-self-start gap-3 mb-3 px-3"
    >
      <button
        pButton
        pRipple
        type="button"
        (click)="toggleShowEventsByDriverGraphs()"
        [icon]="
          showEventsByDriverGraphs ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
        "
        class="p-button-sm p-button-rounded p-button-text"
        style="color: #6c757d"
      ></button>
      <div class="text-uppercase fw-light" style="font-size: 1.2rem">
        RANKING DE EVENTOS CONFIRMADOS POR CONDUCTOR
      </div>
      <div class="align-content-center position-relative"></div>
    </div>
    <div
      *ngIf="allDataLoadedOfEventsByDriver && showEventsByDriverGraphs"
      class="w-100 sortable-list d-flex flex-wrap justify-content-center pb-3 gap-4"
    >
      <ng-container>
        <div
          class="item px-4 py-1"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
            height: fit-content;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              Eventos por conductor
            </div>
            <div class="d-flex flex-row align-items-center gap-2">
              <button
                pButton
                pRipple
                type="button"
                (click)="toggleShowMoreEventsByDriverGraphs()"
                [icon]="
                  showMoreEventsByDriverGraphs ? 'pi pi-minus' : 'pi pi-plus'
                "
                class="p-button-sm p-button-rounded p-button-text"
                style="color: #6c757d"
              ></button>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <div class="w-100 ratio ratio-1x1">
              <p-table
                *ngIf="showTableOfEventsByDriver && eventsByDriver.length > 0"
                [(selection)]="selectEventByDriver"
                [value]="eventsByDriver"
                styleClass="p-datatable-sm border-none"
                [scrollable]="true"
                scrollHeight="flex"
                selectionMode="single"
                dataKey="id"
                (onRowSelect)="onRowSelectInTableEventsByDriver()"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Unidad</th>
                    <th>Operacion</th>
                    <th>Conductor</th>
                    <th>Nro. de infraccion</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-eventsByDriver>
                  <tr [pSelectableRow]="eventsByDriver">
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ eventsByDriver.unit.unitName }}
                    </td>
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ eventsByDriver.unit.operation }}
                    </td>
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ eventsByDriver.driver }}
                    </td>
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ eventsByDriver.events }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <div
                *ngIf="eventsByDriver.length == 0"
                class="d-flex flex-column flex-fill justify-content-evenly gap-2"
              >
                <div style="color: gray" class="d-flex justify-content-center">
                  <svg fill="currentColor" viewBox="0 0 16 16" width="30%">
                    <path
                      d="M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465m-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1"
                    />
                    <path
                      d="M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7m6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.55 4.55 0 0 1 .23-2.002m-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-1.3-1.905"
                    />
                  </svg>
                </div>
                <div class="h3 text-center fw-semibold" style="color: gray">
                  No hay datos disponibles!
                </div>
                <div class="h5 text-center fw-light" style="color: gray">
                  No hay datos para mostrarte en este periodo
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div style="width: clamp(350px, calc(60% - 4.5rem), 60%)">
        <div class="sortable-list d-flex flex-wrap gap-4 justify-content-start">
          <ng-container *ngIf="!showMoreEventsByDriverGraphs">
            <div
              style="
                background-color: rgb(255, 255, 255);
                width: clamp(350px, calc(30% - 3rem), 30%);
              "
            ></div>
            <div
              style="
                background-color: rgb(255, 255, 255);
                width: clamp(350px, calc(30% - 3rem), 30%);
              "
            ></div>
          </ng-container>
          <ng-container
            *ngIf="showMoreEventsByDriverGraphs && selectEventByDriver"
          >
            <div
              class="item px-4 py-1"
              *ngFor="let eventsByDriverChartData of eventsByDriverChartsData"
              style="
                background-color: rgb(255, 255, 255);
                border-radius: 6px;
                border: 1px solid rgb(180, 180, 180);
                width: clamp(350px, calc(50% - 0.75rem), 50%);
              "
            >
              <div
                class="d-flex flex-row justify-content-between align-self-center py-1"
              >
                <div
                  class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
                >
                  {{ eventsByDriverChartsTitles[eventsByDriverChartData.id] }}
                </div>
                <div
                  class="d-flex flex-row align-items-center gap-2"
                  style="min-width: fit-content"
                >
                  <p-button
                    *appHasPermission="'reports_module'"
                    [routerLink]="['/reports']"
                    label="Ver más"
                    styleClass="p-button-link w-100"
                  ></p-button>
                </div>
              </div>
              <div class="d-flex flex-row justify-content-between">
                <app-chart
                  class="w-100 ratio ratio-16x9"
                  [data]="eventsByDriverChartData"
                  [type]="eventsByDriverChartData.datasets[0].type"
                  [options]="
                    eventsByDriverChartsConfig[eventsByDriverChartData.id]
                  "
                  [isEmpty]="
                    eventsByDriverChartData.datasets[0].data.length == 0
                  "
                ></app-chart>
              </div>
            </div>
            <div
              class="item px-4 py-1"
              style="
                background-color: rgb(255, 255, 255);
                border-radius: 6px;
                border: 1px solid rgb(180, 180, 180);
                width: clamp(350px, calc(100%), 100%);
              "
            >
              <div
                class="d-flex flex-row justify-content-between align-self-center py-1"
              >
                <div
                  class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
                >
                  {{ "Mapa de calor de eventos por unidades del conductor" }}
                </div>
                <div
                  class="d-flex flex-row align-items-center gap-2"
                  style="min-width: fit-content"
                >
                  <p-button
                    *appHasPermission="'reports_module'"
                    [routerLink]="['/reports']"
                    label="Ver más"
                    styleClass="p-button-link w-100"
                  ></p-button>
                </div>
              </div>
              <div class="d-flex flex-row justify-content-between">
                <app-chart
                  class="w-100 ratio ratio-16x9"
                  [data]="generalEventsNgxChartsData"
                  [type]="eventsByDriverChartsMoreOptions[0].type"
                  [options]="{}"
                  [isEmpty]="generalEventsNgxChartsData.length == 0"
                  [library]="eventsByDriverChartsMoreOptions[0].library"
                  [colors]="eventsByDriverChartsMoreOptions[0].colors"
                  [showExample]="false"
                ></app-chart>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      *ngIf="!allDataLoadedOfEventsByDriver && showEventsByDriverGraphs"
      class="w-100 justify-content-center d-flex flex-row"
    >
      <div
        class="ratio ratio-1x1 d-flex flex-column align-content-center justify-content-center"
        style="width: 350px"
      >
        <div
          class="d-flex flex-column justify-content-center align-content-center align-items-center"
        >
          <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
          <div class="d-flex flex-row gap-2">
            <div>Cargando</div>
            <div>datos</div>
            <div>...</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- RANKING DE EVENTOS GENERAL -->
  <div
    *appHasPermission="'dashboard_descriptiveGraphic_generalEvents'"
    class="w-100 px-5"
  >
    <div
      class="d-flex flex-row justify-content-start align-self-start gap-3 mb-3 px-3"
    >
      <button
        pButton
        pRipple
        type="button"
        (click)="toggleShowGeneralEventsGraphs()"
        [icon]="
          showGeneralEventsGraphs ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
        "
        class="p-button-sm p-button-rounded p-button-text"
        style="color: #6c757d"
      ></button>
      <div class="text-uppercase fw-light" style="font-size: 1.2rem">
        RANKING DE EVENTOS GENERAL
      </div>
      <div class="align-content-center position-relative"></div>
    </div>
    <div
      *ngIf="allDataLoadedOfGeneralEvents && showGeneralEventsGraphs"
      class="w-100 sortable-list d-flex flex-wrap gap-4 justify-content-center pb-3"
    >
      <ng-container>
        <div
          class="item px-4 py-1"
          *ngFor="let generalEventsChartData of generalEventsChartsData"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              {{ generalEventsChartsTitles[generalEventsChartData.id] }}
            </div>
            <div
              class="d-flex flex-row align-items-center gap-2"
              style="min-width: fit-content"
            >
              <p-button
                label="Ver más"
                (click)="
                  showChartInDialog(
                    generalEventsChartsFull[generalEventsChartData.id],
                    generalEventsChartsConfig[generalEventsChartData.id],
                    generalEventsChartsTitles[generalEventsChartData.id],
                    generalEventsChartsTotals[generalEventsChartData.id].all
                  )
                "
                styleClass="p-button-link w-100"
              ></p-button>

              <button
                *appHasPermission="'reports_module'"
                type="button"
                pButton
                pRipple
                icon="pi pi-ellipsis-v"
                class="p-button-rounded p-button-text"
                (click)="menu.toggle($event)"
              ></button>
              <p-menu #menu [popup]="true" [model]="items"></p-menu>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <app-chart
              class="w-100 ratio ratio-16x9"
              [data]="generalEventsChartData"
              [type]="generalEventsChartData.datasets[0].type"
              [options]="generalEventsChartsConfig[generalEventsChartData.id]"
              [isEmpty]="generalEventsChartData.datasets[0].data.length == 0"
            ></app-chart>
          </div>
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="!allDataLoadedOfGeneralEvents && showGeneralEventsGraphs"
      class="w-100 justify-content-center d-flex flex-row"
    >
      <div
        class="ratio ratio-1x1 d-flex flex-column align-content-center justify-content-center"
        style="width: 350px"
      >
        <div
          class="d-flex flex-column justify-content-center align-content-center align-items-center"
        >
          <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
          <div class="d-flex flex-row gap-2">
            <div>Cargando</div>
            <div>datos</div>
            <div>...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- RANKING DE EVENTOS GENERAL CONFIRMADOS -->
  <!-- <div class="w-100 px-5">
    <div
      class="d-flex flex-row justify-content-start align-self-start gap-3 mb-3 px-3"
    >
      <button
        pButton
        pRipple
        type="button"
        (click)="toggleShowGeneralEventsGraphs()"
        [icon]="
          showGeneralEventsGraphs ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
        "
        class="p-button-sm p-button-rounded p-button-text"
        style="color: #6c757d"
      ></button>
      <div class="text-uppercase fw-light" style="font-size: 1.2rem">
        RANKING DE EVENTOS GENERAL CONFIRMADOS
      </div>
      <div class="align-content-center position-relative"></div>
    </div>
    <div
      *ngIf="allDataLoadedOfGeneralEvents && showGeneralEventsGraphs"
      class="w-100 sortable-list d-flex flex-wrap gap-4 justify-content-center pb-3"
    >
      <ng-container>
        <div
          class="item px-4 py-1"
          *ngFor="let generalEventsChartData of generalEventsChartsData"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              {{ generalEventsChartsTitles[generalEventsChartData.id] }}
            </div>
            <div
              class="d-flex flex-row align-items-center gap-2"
              style="min-width: fit-content"
            >
              <p-button
                *appHasPermission="'reports_module'"
                [routerLink]="['/reports']"
                label="Ver más"
                styleClass="p-button-link w-100"
              ></p-button>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <app-chart
              class="w-100 ratio ratio-16x9"
              [data]="generalEventsChartData"
              [type]="generalEventsChartData.datasets[0].type"
              [options]="generalEventsChartsConfig[generalEventsChartData.id]"
              [isEmpty]="generalEventsChartData.datasets[0].data.length == 0"
            ></app-chart>
          </div>
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="!allDataLoadedOfGeneralEvents && showGeneralEventsGraphs"
      class="w-100 justify-content-center d-flex flex-row"
    >
      <div
        class="ratio ratio-1x1 d-flex flex-column align-content-center justify-content-center"
        style="width: 350px"
      >
        <div
          class="d-flex flex-column justify-content-center align-content-center align-items-center"
        >
          <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
          <div class="d-flex flex-row gap-2">
            <div>Cargando</div>
            <div>datos</div>
            <div>...</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- RANKING DE EXCESO DE VELOCIDAD POR NIVEL POR CONDUCTOR -->
  <div
    *appHasPermission="'dashboard_descriptiveGraphic_excessSpeedPerLevel'"
    class="w-100 px-5"
  >
    <div
      class="d-flex flex-row justify-content-start align-self-start gap-3 mb-3 px-3"
    >
      <button
        pButton
        pRipple
        type="button"
        (click)="toggleShowExcessSpeedPerLevelGraphs()"
        [icon]="
          showExcessSpeedPerLevelGraphs
            ? 'pi pi-chevron-up'
            : 'pi pi-chevron-down'
        "
        class="p-button-sm p-button-rounded p-button-text"
        style="color: #6c757d"
      ></button>
      <div class="text-uppercase fw-light" style="font-size: 1.2rem">
        RANKING DE EXCESO DE VELOCIDAD POR NIVEL
      </div>
      <div class="align-content-center position-relative"></div>
    </div>
    <div
      *ngIf="
        allDataLoadedOfExcessSpeedPerLevel && showExcessSpeedPerLevelGraphs
      "
      class="w-100 sortable-list d-flex flex-wrap justify-content-center pb-3 gap-4"
    >
      <ng-container>
        <div
          class="item px-4 py-1"
          style="
            background-color: rgb(255, 255, 255);
            border-radius: 6px;
            border: 1px solid rgb(180, 180, 180);
            width: clamp(350px, calc(30% - 3rem), 30%);
            min-width: 350px;
          "
        >
          <div
            class="d-flex flex-row justify-content-between align-self-center py-1"
          >
            <div
              class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
            >
              EXCESO DE VELOCIDAD POR NIVEL Y CONDUCTOR
            </div>
            <div class="d-flex flex-row align-items-center gap-2">
              <button
                pButton
                pRipple
                type="button"
                (click)="toggleShowMoreExcessSpeedPerLevelGraphs()"
                [icon]="
                  showMoreExcessSpeedPerLevelGraphs
                    ? 'pi pi-minus'
                    : 'pi pi-plus'
                "
                class="p-button-sm p-button-rounded p-button-text"
                style="color: #6c757d"
              ></button>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <!-- table -->
            <div class="w-100 ratio ratio-1x1">
              <p-table
                *ngIf="
                  showTableOfSpeedingEventsByLevelAndDriver &&
                  speedingEventsByLevelAndDriver.length > 0
                "
                [value]="speedingEventsByLevelAndDriver"
                styleClass="p-datatable-sm border-none"
                [scrollable]="true"
                scrollHeight="flex"
                selectionMode="single"
                dataKey="id"
                (onRowSelect)="
                  onRowSelectInTableOfSpeedingEventsByLevelAndDriver($event)
                "
                [style]="{ 'font-size': '0.8rem' }"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="driver" rowspan="2">Conductor</th>
                    <th colspan="3" class="text-center">Infracción</th>
                  </tr>
                  <tr>
                    <th pSortableColumn="events[0]">Nivel 1</th>
                    <th pSortableColumn="events[1]">Nivel 2</th>
                    <th pSortableColumn="events[2]">Nivel 3</th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-speedingEventsByLevelAndDriver
                >
                  <tr [pSelectableRow]="speedingEventsByLevelAndDriver">
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ speedingEventsByLevelAndDriver.driver }}
                    </td>
                    <td class="text-nowrap overflow-hidden text-truncate">
                      {{ speedingEventsByLevelAndDriver.event }}
                    </td>
                    <td
                      *ngFor="
                        let level of speedingEventsByLevelAndDriver.events
                      "
                      class="text-nowrap overflow-hidden text-truncate"
                    >
                      {{ level }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <div
                *ngIf="speedingEventsByLevelAndDriver.length == 0"
                class="d-flex flex-column flex-fill justify-content-evenly gap-2"
              >
                <div style="color: gray" class="d-flex justify-content-center">
                  <svg fill="currentColor" viewBox="0 0 16 16" width="30%">
                    <path
                      d="M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465m-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1"
                    />
                    <path
                      d="M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7m6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.55 4.55 0 0 1 .23-2.002m-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-1.3-1.905"
                    />
                  </svg>
                </div>
                <div class="h3 text-center fw-semibold" style="color: gray">
                  No hay datos disponibles!
                </div>
                <div class="h5 text-center fw-light" style="color: gray">
                  No hay datos para mostrarte en este periodo
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div style="width: clamp(350px, calc(60% - 4.5rem), 60%)">
        <div class="sortable-list d-flex flex-wrap gap-4 justify-content-start">
          <ng-container *ngIf="!showMoreExcessSpeedPerLevelGraphs">
            <div
              style="
                background-color: rgb(255, 255, 255);
                width: clamp(350px, calc(30% - 3rem), 30%);
              "
            ></div>
            <div
              style="
                background-color: rgb(255, 255, 255);
                width: clamp(350px, calc(30% - 3rem), 30%);
              "
            ></div>
          </ng-container>
          <ng-container *ngIf="showMoreExcessSpeedPerLevelGraphs">
            <div
              class="item px-4 py-1"
              *ngFor="
                let excessSpeedPerLevelChartData of excessSpeedPerLevelChartsData
              "
              style="
                background-color: rgb(255, 255, 255);
                border-radius: 6px;
                border: 1px solid rgb(180, 180, 180);
                width: clamp(350px, calc(50% - 0.75rem), 50%);
              "
            >
              <div
                class="d-flex flex-row justify-content-between align-self-center py-1"
              >
                <div
                  class="fs-5 fw-light text-nowrap overflow-hidden text-truncate"
                >
                  {{
                    excessSpeedPerLevelChartsTitles[
                      excessSpeedPerLevelChartData.id
                    ]
                  }}
                </div>
                <div
                  class="d-flex flex-row align-items-center gap-2"
                  style="min-width: fit-content"
                >
                  <p-button
                    label="Ver más"
                    (click)="
                      showChartInDialog(
                        excessSpeedPerLevelChartsFull[
                          excessSpeedPerLevelChartData.id
                        ],
                        excessSpeedPerLevelChartsConfig[
                          excessSpeedPerLevelChartData.id
                        ],
                        excessSpeedPerLevelChartsTitles[
                          excessSpeedPerLevelChartData.id
                        ],
                        excessSpeedPerLevelChartsTotals[
                          excessSpeedPerLevelChartData.id
                        ]?.all
                      )
                    "
                    styleClass="p-button-link w-100"
                  ></p-button>

                  <button
                    *appHasPermission="'reports_module'"
                    type="button"
                    pButton
                    pRipple
                    icon="pi pi-ellipsis-v"
                    class="p-button-rounded p-button-text"
                    (click)="menu.toggle($event)"
                  ></button>
                  <p-menu #menu [popup]="true" [model]="items"></p-menu>
                </div>
              </div>
              <div class="d-flex flex-row justify-content-between">
                <app-chart
                  class="w-100 ratio ratio-16x9"
                  [data]="excessSpeedPerLevelChartData"
                  [type]="excessSpeedPerLevelChartData.datasets[0].type"
                  [options]="
                    excessSpeedPerLevelChartsConfig[
                      excessSpeedPerLevelChartData.id
                    ]
                  "
                  [isEmpty]="
                    excessSpeedPerLevelChartData.datasets[0].data.length == 0
                  "
                ></app-chart>

                <!-- table -->
                <!-- <div class="w-100 ratio ratio-16x9">
            <p-table
              [value]="products"
              styleClass="p-datatable-sm border-none"
              [scrollable]="true"
              scrollHeight="flex"
              selectionMode="single"
              dataKey="code"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Quantity</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.code }}</td>
                  <td>{{ product.name }}</td>
                  <td>{{ product.category }}</td>
                  <td>{{ product.quantity }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div> -->

                <!-- resumen -->
                <!-- <div class="w-100 ratio ratio-16x9">
            <div class="d-flex flex-column justify-content-around">
              <div class="d-flex flex-row">
                <div class="d-flex flex-column gap-2">
                  <div class="fw-light" style="font-size: 1.1rem">
                    Distancia conducida en este periodo
                  </div>
                  <div class="d-flex flex-row">
                    <div class="fw-light" style="font-size: 5rem">
                      {{ "86387.3" }}
                    </div>
                    <div
                      class="p-2 d-flex flex-column justify-content-center gap-1"
                    >
                      <div class="fw-bold">
                        {{ "-35" }}%
                        <i
                          [ngClass]="
                            false ? 'pi pi-arrow-down' : 'pi pi-arrow-up'
                          "
                        ></i>
                      </div>
                      <div class="fw-light" style="font-size: 2rem">km</div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-fill align-items-center justify-content-center"
                >
                  <div class="fw-light" style="font-size: 0.9rem">
                    Periodo anterior
                  </div>
                  <div class="fw-light" style="font-size: 0.9rem">
                    {{ "133864.7" }} km
                  </div>
                </div>
              </div>

              <div class="d-flex flex-row gap-1 justify-content-center">
                <div
                  class="fw-light d-flex align-items-center justify-content-center"
                  style="font-size: 0.9rem; width: clamp(30%, 40%, 50%)"
                >
                  <div>Total de Unidades: {{ "687" }}</div>
                </div>
                <div
                  class="d-flex flex-column"
                  style="width: clamp(30%, 40%, 50%)"
                >
                  <div
                    class="fw-light d-flex flex-row gap-1 align-items-center"
                  >
                    <div>Unidades con</div>
                    <div pTooltip="GPS" tooltipPosition="top">
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0m-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
                        />
                      </svg>
                    </div>
                    <div>:{{ "387" }}</div>
                  </div>
                  <div
                    class="fw-light d-flex flex-row gap-1 align-items-center"
                  >
                    <div>Unidades con</div>

                    <div pTooltip="CIPIA" tooltipPosition="top">
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                        />
                        <path
                          d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                        />
                      </svg>
                    </div>
                    <div>:{{ "387" }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      *ngIf="
        !allDataLoadedOfExcessSpeedPerLevel && showExcessSpeedPerLevelGraphs
      "
      class="w-100 justify-content-center d-flex flex-row"
    >
      <div
        class="ratio ratio-1x1 d-flex flex-column align-content-center justify-content-center"
        style="width: 350px"
      >
        <div
          class="d-flex flex-column justify-content-center align-content-center align-items-center"
        >
          <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          </div>
          <div class="d-flex flex-row gap-2">
            <div>Cargando</div>
            <div>datos</div>
            <div>...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--  -->
<p-dialog
  [header]="dialogChartsTitles[0]"
  [(visible)]="displayChartsInDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [maximizable]="false"
  [baseZIndex]="10000"
  [draggable]="true"
  [resizable]="false"
>
  <div class="d-flex flex-column justify-content-between">
    <div class="position-relative">
      <div
        class="position-absolute"
        style="top: 50%; left: 50%; transform: translate(-50%, -50%)"
      >
        Total:
        {{ dialogChartsTotals[0] || "-" }}
      </div>
    </div>
    <app-chart
      *ngFor="let dialogChartData of dialogChartsData"
      [ngClass]="getRatioClass(dialogChartData.datasets[0].data.length)"
      [data]="dialogChartData"
      [type]="dialogChartData.datasets[0].type"
      [options]="dialogChartsConfig[0]"
      [isEmpty]="dialogChartData.datasets[0].data.length == 0"
    ></app-chart>
  </div>
</p-dialog>
